import { inject, NgModule } from '@angular/core';

import { Routes, RouterModule } from '@angular/router';
import { SettingsEditPackageComponent } from '@app/pages/settings/packages/edit-package/edit-package.component';
import { SettingsPackagesComponent } from '@app/pages/settings/packages/packages.component';
import { SettingsPdqIqComponent } from '@app/pages/settings/packages/pdq-iq/pdq-iq.component';
import { AccountPageComponent } from './Account/account-page.component';
import { BillingComponent } from './billing/billing.component';
import { IntegrationDetailsComponent } from './integrations/integration-details/integration-details.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { LocationEditComponent } from './locations/location-edit/location-edit.component';
import { LocationsComponent } from './locations/locations.component';
import { CanDeactivateEditPackageGuard } from './packages/edit-package/edit-package-guard/deactivate-edit-package-gurad';
import { VerificationsComponent } from './verifications/verifications.component';
import { InternationalComponent } from './international/international.component';
import { UsersAndPermissionsComponent } from './users-and-permissions/users-and-permissions.component';
import { CanActivateWriteRoute } from '../../core/guards/write-role.guard';
import { CanActivateLocationRoute } from './common/guards/locations-tab.guard';
import { LinkUpComponent } from '@settings/link-up/link-up.component';
import { NotificationsPageComponent } from './notifications/notifications-page.component';
import { SettingsComponent } from '../checkout-app/checkout-layout/main/components/settings/settings.component';
import { MaxxSettingsPageComponent } from './maxx/maxx-settings-page.component';
import { maxxSettingsGuard } from './maxx/maxx-settings.guard';

const routes: Routes = [
  {
    path: '',
    title: 'Settings',
    children: [
      { path: 'account', component: AccountPageComponent },
      {
        path: 'locations',
        component: LocationsComponent,
        canActivate: [() => inject(CanActivateLocationRoute).canActivate()],
      },
      {
        path: 'locations/edit-location/:id',
        component: LocationEditComponent,
        canActivate: [() => inject(CanActivateLocationRoute).canActivate()],
      },
      { path: 'verifications', component: VerificationsComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'international', component: InternationalComponent },
      { path: 'packages', component: SettingsPackagesComponent },
      {
        path: 'delivery-services',
        loadChildren: () => import('../../pages/delivery-service/carriers.module').then((m) => m.CarriersModule),
      },
      {
        title: 'Checkout settings',
        path: 'checkout',
        component: SettingsComponent,
      },
      {
        path: 'packages/edit-package',
        component: SettingsEditPackageComponent,
        canDeactivate: [() => inject(CanDeactivateEditPackageGuard).canDeactivate()],
      },
      { path: 'integrations', component: IntegrationsComponent },
      { path: 'integrations/:name', component: IntegrationDetailsComponent },
      {
        path: 'packages/edit-package/:id',
        component: SettingsEditPackageComponent,
        canDeactivate: [() => inject(CanDeactivateEditPackageGuard).canDeactivate()],
      },
      {
        path: 'packages/pdq-iq',
        component: SettingsPdqIqComponent,
      },
      {
        path: 'users-and-permissions',
        component: UsersAndPermissionsComponent,
        canActivate: [() => inject(CanActivateWriteRoute).canActivate()],
      },
      { path: 'notifications', component: NotificationsPageComponent },
      { path: 'link-up', component: LinkUpComponent },
      {
        title: 'MAXX settings',
        path: 'maxx',
        component: MaxxSettingsPageComponent,
        canActivate: [maxxSettingsGuard],
      },
      { path: '**', redirectTo: 'account', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  providers: [CanActivateWriteRoute],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRouterModule {}
